<div class="row">                            
    <div class="col-3">
        <app-control label='Id' type="string" [(ngModel)]="model.id" isDisabled="true"/>                                
    </div>

    <div class="col-3">
        <app-control 
            label='Document status' 
            [(ngModel)]="model.statusId" 
            type="codelist"
            codelist="VesselVisitDocumentStatus" 
            [required]="true" 
            [useCache]="false"
            isDisabled="true"/>                         
    </div>
    
    <div class="col-3">
        <app-control label="Vessel Name" type="string" [(ngModel)]="model.vesselVisit.vessel.name"  isDisabled="true"/>                                
    </div>

    <div class="col-3">
        <app-control label="IMO" type="string" [(ngModel)]="model.vesselVisit.vessel.imo"  isDisabled="true"/>                                
    </div>
</div>                            

<div class="row">
    <div class="col-12">
        <app-control label="Note" type="string" [(ngModel)]="model.note" [isDisabled]="isDisabled('note')"/>                                
    </div>
</div>

<div class="row">
    <div class="col-3">
        <app-control label='Created Date' type="datetime" [isDisabled]="true" [(ngModel)]="model.createdDate"/>
    </div>

    <div class="col-3">
        <app-control label="Created By" type="string" [isDisabled]="true" [ngModel]="createdByFullName"/>                                
    </div>

    <div class="col-3">
        <app-control label='Last Modified Date' type="datetime" [isDisabled]="true" [(ngModel)]="model.lastModifiedDate"/>
    </div>

    <div class="col-3">
        <app-control label="Last Modified By" type="string" [isDisabled]="true" [ngModel]="lastModifiedByFullName"/>                                
    </div>
</div>